import $ from 'jquery';
import _ from '_';
import cx from 'classnames';
import React from 'react';
import ReactDOM from 'react-dom';
import Reflux from 'reflux';
import Utils from 'medscape/utils';
/*
  Time Label

  Displays the current time and the total time of the playing media.
*/
export default class TimeLabel extends React.Component{
    constructor(props){
        super(props);
        this.state={};
    }
    componentDidMount() { }
    render() {
      const TimeProps = {
        ControlsStore: this.props.ControlsStore,
        getPrettyTime: (seconds) =>{
          return Utils.secondsToPrettyTime(seconds);
        }
      }
      return (
        <div className="duration">
          <CurrentTime {...TimeProps} />
          <span className="separator">/</span>
          <DurationTime {...TimeProps} />
        </div>
      )
    }
}

TimeLabel.propTypes={
  ControlsStore: React.PropTypes.object.isRequired
}
TimeLabel.defaultProps={
}
class CurrentTime extends Reflux.Component{
  constructor(props) {
    super(props);
    this.state={};
    this.store = props.ControlsStore;
  }
  shouldComponentUpdate(nextProps, nextState) {
    return nextState.currentTime!=this.state.currentTime;
  }
  render() {
    let time=this.props.getPrettyTime(this.state.currentTime);
    return (<span className="curtimetext">{ time}</span>)
  }

}

CurrentTime.propTypes={
  ControlsStore: React.PropTypes.object.isRequired,
  getPrettyTime: React.PropTypes.func.isRequired
}
CurrentTime.defaultProps={
}

class DurationTime extends Reflux.Component{
    constructor(props){
        super(props);
        this.state={};
      this.store = props.ControlsStore;
    }

    shouldComponentUpdate(nextProps, nextState){
        return nextState.duration!=this.state.duration;
    }

  render() {
    let time=this.props.getPrettyTime(this.state.duration);
    return (<span className="durtimetext">{ time}</span>)
  }

}

DurationTime.propTypes={
  ControlsStore: React.PropTypes.object.isRequired,
  getPrettyTime: React.PropTypes.func.isRequired
}
DurationTime.defaultProps={
}



// WEBPACK FOOTER //
// ./medscape_modules/video/player-controls/time-label.jsx